<script setup lang="ts">
defineProps<{
  title: string;
  numberActivedFilters?: number;
  hasActiveFilters?: string | boolean | number | Date | null;
}>();
</script>

<template>
  <button
    class="bg-gray-100 text-gray-700 border border-gray-300 py-2 px-3 rounded-xl font-semibold hover:bg-gray-200 transition-transform transform hover:-translate-y-0.5 cursor-pointer sm:px-6"
    :class="{ 'bg-red-50 border-red-300 text-red-700': hasActiveFilters }"
    v-bind="$attrs"
  >
    {{ title }}

    <span v-if="hasActiveFilters" class="ml-1">
      ({{ numberActivedFilters }})
    </span>
  </button>
</template>
